import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'momentDate'})
export class MomentDatePipe implements PipeTransform {

  transform(value, format?: string) {
    if (value) {
      return value.format(format || 'DD.MM.YYYY');
    }
  }
}
